export default __webpack_public_path__ + "static/media/istockphoto-1276373630-1024x1024.1a737360.jpg";